module.exports = __webpack_public_path__ + "img/demo_woman4.993b7538.svg";